import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'

export const resendIntegration: BetterstartIntegrationDefinition = {
  id: 'resend',
  title: 'Resend',
  description: 'Email delivery for auth and form notifications',
  kind: 'email',
  version: '1.0.1',
  dependencies: [],
  conflicts: [],
  files: [
    {
      outputPath: 'lib/actions/resend/get-env-value.ts',
      templatePath: 'actions/get-env-value.ts'
    },
    {
      outputPath: 'lib/actions/resend/get-from-address.ts',
      templatePath: 'actions/get-from-address.ts'
    },
    {
      outputPath: 'lib/actions/resend/get-resend-client.ts',
      templatePath: 'actions/get-resend-client.ts'
    },
    {
      outputPath: 'lib/actions/resend/is-configured.ts',
      templatePath: 'actions/is-configured.ts'
    },
    {
      outputPath: 'lib/actions/resend/html-to-text.ts',
      templatePath: 'actions/html-to-text.ts'
    },
    {
      outputPath: 'lib/actions/resend/send-email.ts',
      templatePath: 'actions/send-email.ts'
    },
    {
      outputPath: 'lib/actions/resend/escape-html.ts',
      templatePath: 'actions/escape-html.ts'
    },
    {
      outputPath: 'lib/actions/resend/render-password-reset-email.ts',
      templatePath: 'actions/render-password-reset-email.ts'
    },
    {
      outputPath: 'lib/actions/resend/provider.ts',
      templatePath: 'actions/provider.ts'
    }
  ],
  packageDependencies: ['resend'],
  devDependencies: [],
  capabilities: {
    emailProvider: {
      provider: 'resend',
      importPath: '@admin/actions/resend/provider',
      exportName: 'resendEmailProvider'
    }
  },
  envSections: [
    {
      header: 'Email (Resend)',
      vars: [
        { key: 'BETTERSTART_RESEND_API_KEY', value: '' },
        { key: 'BETTERSTART_EMAIL_FROM', value: 'noreply@yourdomain.com' }
      ]
    }
  ],
  configure: 'resend'
}
